import { Button, TextBlock, VersionField } from '../../atoms';
import React, { useState } from 'react';

import clsx from 'clsx';
import useStyles from './ConfirmModal.styles';

interface IConfirmModalProps {
  open?: boolean;
  // eslint-disable-next-line
  confirmModalAction: (...args: any[]) => void;
  headerText: string;
  text: string;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  type?: 'simple' | 'withInputField';
  inputMask?: string;
  inputPlaceholder?: string;
  // eslint-disable-next-line
  input?: any | any[];
  closeConfirmModal: () => void;
}

export const ConfirmModal: React.FC<IConfirmModalProps> = ({
  open,
  confirmModalAction,
  headerText,
  text,
  buttonText,
  buttonSize,
  type = 'simple',
  inputMask,
  inputPlaceholder = '__.__.__.__',
  input,
  closeConfirmModal,
}) => {
  const [errorInputFormat, setErrorInputFormat] = useState<boolean>(false);
  const [isApplyEnabled, setApplyEnabled] = useState<boolean>(
    type == 'withInputField' ? false : true,
  );
  const [inputFieldData, setInputFieldData] = useState<string>();

  const classes = useStyles();

  const handleCloseClick = () => closeConfirmModal();
  const handleModalActionClick = () => {
    if (!errorInputFormat) {
      confirmModalAction(input, inputFieldData);
    }
  };

  const changeInputVersion = (value: string) => {
    setErrorInputFormat(false);
    if (value.trim() == '') {
      setApplyEnabled(false);
    } else {
      setInputFieldData(value);
      setApplyEnabled(true);
    }
  };

  const handleBlur = (event: {
    target: { validity: { patternMismatch: boolean } };
  }) => {
    if (event.target.validity.patternMismatch) {
      setErrorInputFormat(true);
    }
  };

  return (
    <>
      {open && (
        <div
          className={clsx(classes.root, {
            [classes.inputSpace]: type === 'withInputField',
          })}
          data-qa-name="modal_window"
        >
          <div className={classes.titleContainer}>
            <div className={classes.title}>
              <TextBlock type="titleConfirmModalTB" text={headerText} />
            </div>
          </div>
          <div className={classes.textContainer}>
            <TextBlock type="textConfirmModalTB" text={text} />
            {type == 'withInputField' && (
              <div className={classes.versionField}>
                <VersionField
                  placeholder={inputPlaceholder}
                  changeInputVersion={changeInputVersion}
                  size={'medium'}
                  errorInputFormat={errorInputFormat}
                  handleBlur={handleBlur}
                  inputMask={inputMask}
                />
              </div>
            )}
          </div>
          <div className={classes.buttons}>
            <Button onAction={handleCloseClick} size={buttonSize}>
              Cancel
            </Button>
            <Button
              onAction={handleModalActionClick}
              color="blue"
              size={buttonSize}
              disabled={!isApplyEnabled}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
